import React, { useState } from "react";
import {
  FaChevronDown,
  FaQuestionCircle,
  FaShoppingBag,
  FaTruck,
  FaUndoAlt,
  FaCreditCard,
  FaShieldAlt,
  FaHeadset,
} from "react-icons/fa";

const faqData = [
  {
    icon: <FaShoppingBag />,
    question: "What products can I purchase from Glamira?",
    answer:
      "Glamira offers a wide range of quality products across multiple categories, carefully selected to provide customers with value, reliability, and a seamless shopping experience.",
  },
  {
    icon: <FaTruck />,
    question: "How long does delivery take?",
    answer:
      "Delivery times vary depending on your location and product availability. Most orders are delivered within 3–7 business days, while remote locations may require additional time.",
  },
  {
    icon: <FaTruck />,
    question: "How can I track my order?",
    answer:
      "Once your order is shipped, you will receive tracking details via email or SMS. You can also log in to your account to check your order status anytime.",
  },
  {
    icon: <FaUndoAlt />,
    question: "Can I return or replace a product?",
    answer:
      "Yes. Eligible products can be returned or replaced within the applicable return window, provided they are unused, in original packaging, and satisfy our return policy conditions.",
  },
  {
    icon: <FaCreditCard />,
    question: "Which payment methods do you accept?",
    answer:
      "We support secure payments through UPI, Debit Cards, Credit Cards, Net Banking, Wallets, and other payment options available during checkout.",
  },
  {
    icon: <FaShieldAlt />,
    question: "Is my payment information secure?",
    answer:
      "Absolutely. We use secure payment gateways and industry-standard encryption technologies to ensure your payment information remains protected.",
  },
  {
    icon: <FaShoppingBag />,
    question: "Can I cancel my order?",
    answer:
      "Orders may be cancelled before they are processed or dispatched. Once shipped, cancellation requests may not be possible. Please contact customer support for assistance.",
  },
  {
    icon: <FaHeadset />,
    question: "How can I contact customer support?",
    answer:
      "You can reach our support team through the Contact Us page. We're here to assist with orders, returns, payments, and any questions about your shopping experience.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "60px 0",
      }}
    >
      <div className="container">

        {/* Hero Section */}

        <div
          className="text-center text-white rounded-4 shadow-lg p-5 mb-5"
          style={{
            background:
              "linear-gradient(135deg,#0f172a 0%,#2563eb 100%)",
          }}
        >
          <FaQuestionCircle size={60} className="mb-3" />

          <h1 className="display-4 fw-bold">
            Frequently Asked Questions
          </h1>

          <p className="lead mt-3 mb-0">
            Find quick answers to the most common questions about shopping,
            payments, deliveries, returns, and customer support.
          </p>
        </div>

        {/* Intro Card */}

        <div className="card border-0 shadow-sm rounded-4 mb-5">
          <div className="card-body p-5 text-center">

            <h3 className="fw-bold mb-3">
              Need Help?
            </h3>

            <p className="text-muted mb-0">
              We've compiled answers to frequently asked questions to make your
              shopping experience easier. If you can't find what you're looking
              for, our customer support team is always happy to help.
            </p>

          </div>
        </div>

        {/* FAQ Section */}

        <div className="row justify-content-center">
          <div className="col-lg-10">

            {faqData.map((item, index) => (
              <div
                key={index}
                className="card border-0 shadow-sm rounded-4 mb-3"
                style={{
                  overflow: "hidden",
                  transition: "0.3s",
                }}
              >
                <div
                  className="card-body p-0"
                  style={{ cursor: "pointer" }}
                  onClick={() => toggle(index)}
                >
                  <div className="d-flex justify-content-between align-items-center p-4">

                    <div className="d-flex align-items-center">

                      <div
                        className="rounded-circle text-white d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: 50,
                          height: 50,
                          background:
                            "linear-gradient(135deg,#2563eb,#1d4ed8)",
                        }}
                      >
                        {item.icon}
                      </div>

                      <h5 className="fw-bold mb-0">
                        {item.question}
                      </h5>

                    </div>

                    <FaChevronDown
                      style={{
                        transform:
                          openIndex === index
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        transition: "0.3s",
                      }}
                    />

                  </div>

                  {openIndex === index && (
                    <div
                      className="px-4 pb-4"
                      style={{
                        animation: "fadeIn 0.3s ease",
                      }}
                    >
                      <div
                        className="p-3 rounded-3"
                        style={{
                          background: "#f8fafc",
                          borderLeft: "4px solid #2563eb",
                        }}
                      >
                        <p className="text-muted mb-0">
                          {item.answer}
                        </p>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            ))}

          </div>
        </div>

        {/* Quick Help Cards */}

        <div className="row mt-5 g-4">

          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 h-100 text-center p-4">
              <h1>🚚</h1>
              <h5 className="fw-bold mt-3">Fast Delivery</h5>
              <p className="text-muted">
                Reliable shipping partners ensure your orders reach you safely
                and on time.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 h-100 text-center p-4">
              <h1>🔒</h1>
              <h5 className="fw-bold mt-3">Secure Payments</h5>
              <p className="text-muted">
                Every transaction is protected using trusted payment gateways
                and encryption.
              </p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 h-100 text-center p-4">
              <h1>🎧</h1>
              <h5 className="fw-bold mt-3">Customer Support</h5>
              <p className="text-muted">
                Our dedicated support team is ready to help with your questions
                and concerns.
              </p>
            </div>
          </div>

        </div>

        {/* CTA */}

        <div
          className="text-center text-white rounded-4 p-5 mt-5 shadow-lg"
          style={{
            background:
              "linear-gradient(135deg,#2563eb,#1e40af)",
          }}
        >
          <h2 className="fw-bold">
            Still Have Questions?
          </h2>

          <p className="lead mt-3 mb-4">
            Our support team is here to assist you before, during, and after
            your purchase.
          </p>

          <a
            href="/contact"
            className="btn btn-light btn-lg px-5 fw-bold"
          >
            Contact Us
          </a>
        </div>

        {/* Footer */}

        <div className="text-center mt-5 pt-4 border-top">
          <p className="text-muted mb-2">
            We are committed to providing a transparent, secure, and enjoyable
            shopping experience for every customer.
          </p>

          <small className="text-secondary">
            © {new Date().getFullYear()} Glamira. All Rights Reserved.
          </small>
        </div>

      </div>
    </div>
  );
};

export default Faq;